import Home from "pages/Restaurant/Home";

export default function HomePage() {
  return <Home />;
}
